/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum FeatureCategory {
    AI = 'AI',
    AI_AGENT = 'AI_AGENT',
    BROKER = 'BROKER',
    COMPLIANCE = 'COMPLIANCE',
    CORESTACK_IDENTITY = 'CORESTACK_IDENTITY',
    COST = 'COST',
    GOVERNANCE = 'GOVERNANCE',
    HEATSTACK = 'HEATSTACK',
    OPERATIONS_GOVERNANCE = 'OPERATIONS_GOVERNANCE',
    OTHERS = 'OTHERS',
    REPORT_GENERATION = 'REPORT_GENERATION',
    REPORTS = 'REPORTS',
    RESOURCE_INVENTORY = 'RESOURCE_INVENTORY',
    SECURITY_GOVERNANCE = 'SECURITY_GOVERNANCE',
    UI = 'UI'
}
